import { post, get, put } from './base';

const URL = '/accounts';

export const PostLoginAPI = payload => post(`${URL}/auth/login/`, payload);
export const GetVerificationAPI = tid =>
  get(`${URL}/id-verification-info/${tid}/`);
export const PostRegisterAPI = payload =>
  post(`${URL}/auth/register/`, payload);
export const PostTokenVerifyAPI = payload =>
  post(`${URL}/auth/token/verify/`, payload);
export const PostTokenRefreshAPI = payload =>
  post(`${URL}/auth/token/refresh/`, payload);
export const PostPasswordResetAPI = payload =>
  post(`${URL}/auth/password-reset/`, payload);
export const PostPasswordChangeAPI = (payload, config) =>
  post(`${URL}/auth/user/password/`, payload, config);
export const PostLogoutAPI = () => post(`${URL}/auth/logout/`);

// SNS
export const PostKakaoAPI = payload => post(`${URL}/auth/kakao/`, payload);
export const PostKakaoConnectAPI = (payload, config) =>
  post(`${URL}/auth/kakao/connect/`, payload, config);
export const PostNaverAPI = payload => post(`${URL}/auth/naver/`, payload);
export const PostNaverConnectAPI = (payload, config = {}) =>
  post(`${URL}/auth/naver/connect/`, payload, config);
export const PostGoogleAPI = payload => post(`${URL}/auth/google/`, payload);
export const PostGoogleConnectAPI = (payload, config = {}) =>
  post(`${URL}/auth/google/connect/`, payload, config);
export const PostFacebookAPI = payload =>
  post(`${URL}/auth/facebook/`, payload);
export const PostFacebookConnectAPI = (payload, config = {}) =>
  post(`${URL}/auth/facebook/connect/`, payload, config);
export const PostAppleAPI = payload => post(`${URL}/auth/apple/`, payload);
export const PostAppleConnectAPI = (payload, config = {}) =>
  post(`${URL}/auth/apple/connect/`, payload, config);
export const PostDisconnectSocialAPI = (id, payload, config) =>
  post(`${URL}/auth/socialaccounts/${id}/disconnect/`, payload, config);

// Profile
export const GetMyAccountAPI = config => get(`${URL}/auth/user/`, config);
export const GetSocialAccountsAPI = config =>
  get(`${URL}/auth/socialaccounts/`, config);
export const PutKeywordsAPI = (payload, config) =>
  put(`${URL}/auth/user/keywords/`, payload, config);
export const PutUserProfileAPI = (payload, config) =>
  put(`${URL}/auth/user/`, payload, config);
export const PutChangePhoneNumberAPI = (payload, config) =>
  put(`${URL}/auth/user/phone-number/`, payload, config);
export const PutMarketingAgreedAPI = (payload, config) =>
  put(`${URL}/auth/user/agreed-marketing/`, payload, config);
export const PutPushNotificationAgreedAPI = (payload, config) =>
  put(`${URL}/auth/user/agreed-push-notification/`, payload, config);
export const PostDeactiveUserAPI = config =>
  post(`${URL}/auth/deactivate/`, {}, config);
export const PutProfileImageAPI = (payload, config) =>
  put(`${URL}/auth/user/profile-picture/`, payload, config);

// Email Verification
export const PostEmailVerificationRequestAPI = payload =>
  post(`${URL}/email-verification/request/`, payload);
export const PostEmailVerificationVerifyAPI = payload =>
  post(`${URL}/email-verification/verify/`, payload);

// Password Reset (Email-based)
export const PostPasswordResetRequestAPI = payload =>
  post(`${URL}/password-reset/request/`, payload);
export const PostPasswordResetConfirmAPI = payload =>
  post(`${URL}/password-reset/confirm/`, payload);
